import React, { useState, useEffect } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TablePagination,
  TextField,
  Chip,
  Alert,
  Button,
  CircularProgress,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Divider,Tooltip
} from '@mui/material';
import {
  Search,
  CheckCircle,
  Cancel,
  HowToReg,
  MoreVert,
  Fingerprint,
  VerifiedUser,
  Email,
  Person,
  Work,
  Business,Info
} from '@mui/icons-material';
import axios from 'axios';
import EmployeeIDForm from './EmployeeIDGenerate';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const OfferManagementCandidate = () => {
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredCandidates, setFilteredCandidates] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [employeeFormOpen, setEmployeeFormOpen] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedMenuCandidate, setSelectedMenuCandidate] = useState(null);
  const [verificationDialogOpen, setVerificationDialogOpen] = useState(false);
  const [previousCompanyEmail, setPreviousCompanyEmail] = useState('');
  const [sendingVerification, setSendingVerification] = useState(false);
  const [dialogCandidate, setDialogCandidate] = useState(null); // New state for dialog
  const [seatStatus, setSeatStatus] = useState(null);

  const fetchSeatStatus = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;
      const res = await axios.get(`${API_URL}/api/alldetails/seat-limit`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.data?.success && res.data?.data) {
        setSeatStatus(res.data.data);
      }
    } catch (err) {
    }
  };

  // Get company_id from token
  const getCompanyId = () => {
    const token = localStorage.getItem('token');
    if (!token) return null;
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.company_id;
    } catch (error) {
      return null;
    }
  };

  const fetchHRCompletedCandidates = async () => {
    try {
      setLoading(true);
      const company_id = getCompanyId();
      if (!company_id) {
        alert("No company ID found. Please log in.");
        return;
      }

      const response = await axios.get(`${API_URL}/api/interviews/hr-completed-selected/all`, {
        params: {
          page: page + 1,
          limit: rowsPerPage
        },
        headers:{
          Authorization:`Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.data.success) {
        setCandidates(response.data.candidates);
        setFilteredCandidates(response.data.candidates);
        setTotalRecords(response.data.totalRecords);
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      alert('Failed to fetch candidates: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHRCompletedCandidates();
    fetchSeatStatus();
  }, [page, rowsPerPage]);

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredCandidates(candidates);
    } else {
      const lowercasedQuery = searchQuery.toLowerCase();
      const filtered = candidates.filter((candidate) => {
        return (
          candidate.name.toLowerCase().includes(lowercasedQuery) ||
          candidate.candidateEmail.toLowerCase().includes(lowercasedQuery) ||
          candidate.positionApplied.toLowerCase().includes(lowercasedQuery) ||
          (candidate.offerstatus && candidate.offerstatus.toLowerCase().includes(lowercasedQuery))
        );
      });
      setFilteredCandidates(filtered);
    }
  }, [searchQuery, candidates]);

  const handleOpenEmployeeForm = (candidate) => {
    setSelectedCandidate(candidate);
    setEmployeeFormOpen(true);
    handleCloseMenu();
  };

  const handleCloseEmployeeForm = () => {
    setEmployeeFormOpen(false);
    setSelectedCandidate(null);
    fetchHRCompletedCandidates();
    fetchSeatStatus();
  };

  // Menu handlers
  const handleOpenMenu = (event, candidate) => {
    setMenuAnchorEl(event.currentTarget);
    setSelectedMenuCandidate(candidate);
  };

  const handleCloseMenu = () => {
    setMenuAnchorEl(null);
    // Don't reset selectedMenuCandidate here - we need it for the dialog
  };

  // Background Verification handlers
  const handleOpenVerificationDialog = (candidate) => {
    // Store candidate data in a separate state for the dialog
    setDialogCandidate(candidate);
    setPreviousCompanyEmail('');
    setVerificationDialogOpen(true);
    // Close menu but keep the candidate data
    setMenuAnchorEl(null);
  };

  const handleCloseVerificationDialog = () => {
    setVerificationDialogOpen(false);
    setPreviousCompanyEmail('');
    setDialogCandidate(null);
    // Now we can reset the menu candidate
    setSelectedMenuCandidate(null);
  };

const handleSendVerification = async () => {
  if (!previousCompanyEmail) {
    alert('Please enter the previous company HR email address');
    return;
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(previousCompanyEmail)) {
    alert('Please enter a valid email address');
    return;
  } 

  setSendingVerification(true);
  try {

    const token = localStorage.getItem('token');
    // Make actual API call
    const company_id = getCompanyId();
    const response = await axios.post(
      `${API_URL}/api/background-verification/${dialogCandidate.interviewId}/send-verification`,
      {
        previousCompanyEmail: previousCompanyEmail,
      },{
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );

    if (response.data.success) {
      alert(`Background verification request sent successfully to ${previousCompanyEmail}`);
      handleCloseVerificationDialog();
      fetchHRCompletedCandidates(); // Refresh the list to show updated status
    } else {
      throw new Error(response.data.message);
    }
    
  } catch (error) {
    alert('Failed to send background verification: ' + (error.response?.data?.message || error.message));
  } finally {
    setSendingVerification(false);
  }
};

  const handleGenerateID = (candidate) => {
    handleOpenEmployeeForm(candidate);
  };

  const getOfferStatusChip = (status) => {
    const statusConfig = {
      'accepted': {
        color: '#c8e6c9',
        textColor: '#1b5e20',
        label: 'Accepted',
        icon: <CheckCircle fontSize="small" />
      },
      'rejected': {
        color: '#ffcdd2',
        textColor: '#b71c1c',
        label: 'Rejected',
        icon: <Cancel fontSize="small" />
      },
      'pending': {
        color: '#fff9c4',
        textColor: '#f57f17',
        label: 'Pending',
        icon: <HowToReg fontSize="small" />
      }
    };

    const actualStatus = status?.toLowerCase();
    const config = statusConfig[actualStatus] || statusConfig.pending;
    
    return (
      <Chip
        label={config.label}
        icon={config.icon}
        size="small"
        sx={{
          backgroundColor: config.color,
          color: config.textColor,
          fontWeight: 'bold',
          minWidth: 100,
          '& .MuiSvgIcon-root': { color: config.textColor }
        }}
      />
    );
  };

  const getOfferSentChip = (offerSent) => {
    return offerSent ? (
      <Chip 
        label="Yes"
        sx={{ 
          backgroundColor: '#c8e6c9',
          color: '#1b5e20',
          fontWeight: 'bold'
        }}
      />
    ) : (
      <Chip 
        label="No"
        sx={{ 
          backgroundColor: '#ffcdd2',
          color: '#b71c1c',
          fontWeight: 'bold'
        }}
      />
    );
  };
  // NEW: Get BGV Summary Tooltip
  const getBGVSummaryTooltip = (candidate) => {
    if (!candidate.bgvsummary || candidate.bgvsummary === 'Pending' || candidate.bgvsummary === 'Pending - Email sent') {
      return null;
    }

    return (
      <Tooltip 
        title={
          <Box sx={{ p: 1, maxWidth: 300 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
              Background Verification Summary:
            </Typography>
            <Typography variant="body2">
              {candidate.bgvsummary}
            </Typography>
            {candidate.bgvresponsedate && (
              <Typography variant="caption" sx={{ color: 'text.secondary', mt: 1, display: 'block' }}>
                Response Date: {new Date(candidate.bgvresponsedate).toLocaleDateString()}
              </Typography>
            )}
          </Box>
        }
        arrow
        placement="left"
      >
        <Info 
          fontSize="small" 
          sx={{ 
            color: 'primary.main',
            cursor: 'pointer',
            '&:hover': { color: 'primary.dark' }
          }} 
        />
      </Tooltip>
    );
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Box>
      {/* Tenant User Seat Status Warning Banner */}
      {seatStatus && (seatStatus.isLimitReached || seatStatus.isExpired) && (
        <Alert 
          severity="warning" 
          sx={{ mb: 2, borderRadius: 1 }}
        >
          {seatStatus.isExpired 
            ? "Your subscription/trial has expired. Please upgrade your plan to generate Employee IDs."
            : `User seat limit reached (${seatStatus.usedSeats}/${seatStatus.totalSeats}). Your current plan does not allow adding more employees. Please upgrade your subscription.`}
        </Alert>
      )}

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <TextField
          label="Search Candidates"
          variant="outlined"
          size="small"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          InputProps={{
            endAdornment: <Search color="action" />,
          }}
          sx={{ width: 300 }}
        />
      </Box>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper} elevation={2}>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                <TableCell sx={{ fontWeight: 'bold' }}>Candidate details</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Position</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>HR Round Status</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Selection Result</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Official Offer Sent</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Offer Status</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Offer Response Date</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Background Verfication response</TableCell>

                <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredCandidates.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    <Typography variant="body1" sx={{ p: 2 }}>
                      No candidates found who have completed HR rounds and are selected.
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                filteredCandidates.map((candidate) => (
                  <TableRow key={candidate.interviewId} hover>
                    <TableCell>{candidate.name} {candidate.candidateEmail}</TableCell>
                    <TableCell>{candidate.positionApplied}</TableCell>
                    <TableCell>
                      <Chip 
                        label="Completed" 
                        color="success" 
                        size="small"
                        sx={{ fontWeight: 'bold' }}
                      />
                    </TableCell>
                    <TableCell>
                      <Chip 
                        label="Selected" 
                        color="success" 
                        size="small"
                        sx={{ fontWeight: 'bold' }}
                      />
                    </TableCell>
                    <TableCell>
                      {getOfferSentChip(candidate.offerSent)}
                    </TableCell>
                    <TableCell>
                      {getOfferStatusChip(candidate.offerStatus)}
                    </TableCell>
                    <TableCell>
                      {candidate.offerResponseDate
                        ? new Date(candidate.offerResponseDate).toLocaleDateString()
                        : "-"}
                    </TableCell>
   <TableCell>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Chip 
                            label={candidate.bgvemailsent ? "Email Sent" : "Not Sent"} 
                            size="small"
                            color={candidate.bgvemailsent ? "primary" : "default"}
                            variant={candidate.bgvemailsent ? "filled" : "outlined"}
                          />
                          {getBGVSummaryTooltip(candidate)}
                        </Box>
                        <Chip 
                          label={candidate.bgvstatus || "Pending"} 
                          size="small"
                          color={
                            candidate.bgvstatus === "Verified" ? "success" :
                            candidate.bgvstatus === "Discrepancy Found" ? "error" : "warning"
                          }
                        />
                        {candidate.bgvresponsedate && (
                          <Typography variant="caption" color="textSecondary">
                            Response: {new Date(candidate.bgvresponsedate).toLocaleDateString()}
                          </Typography>
                        )}
                      </Box>
                    </TableCell>
                       <TableCell>
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    {/* {candidate.offerStatus?.toLowerCase() === "accepted" && !candidate.employeeidgenerated ? (
      <Button
        variant="contained"
        color="primary"
        size="small"
        onClick={() => handleGenerateID(candidate)}
        sx={{
          borderRadius: 1,
          textTransform: "none",
        }}
      >
        Generate ID
      </Button>
    ) : candidate.employeeidgenerated ? (
      <Chip
        label="Generated"
        color="success"
        size="small"
        sx={{ fontWeight: "bold" }}
      />
    ) : (
      <Typography variant="body2" color="textSecondary">
        Not Applicable
      </Typography>
    )} */}
    {candidate.employeeidgenerated && (
      <Chip
        label="Generated"
        color="success"
        size="small"
        sx={{ fontWeight: "bold" }}
      />)}
    {/* Conditionally show 3 dots icon only when there are actions available */}
    {!candidate.employeeidgenerated && (
      <IconButton
        size="small"
        onClick={(event) => handleOpenMenu(event, candidate)}
        sx={{
          border: '1px solid #e0e0e0',
          borderRadius: 1,
          padding: '4px'
        }}
      >
        <MoreVert fontSize="small" />
      </IconButton>
    )}
  </Box>
</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={totalRecords}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      )}

      {/* 3-dot Menu */}
      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleCloseMenu}
        PaperProps={{
          elevation: 3,
          sx: {
            minWidth: 200,
            borderRadius: 1
          }
        }}
      >
        <MenuItem 
          onClick={() => handleOpenVerificationDialog(selectedMenuCandidate)}
          disabled={selectedMenuCandidate?.offerStatus?.toLowerCase() !== "accepted"}
        >
          <ListItemIcon>
            <VerifiedUser fontSize="small" />
          </ListItemIcon>
          <ListItemText>Background Verification</ListItemText>
        </MenuItem>
        
        <Tooltip
          title={
            seatStatus?.isExpired
              ? "Subscription expired. Upgrade plan to generate ID."
              : seatStatus?.isLimitReached
              ? `User seat limit reached (${seatStatus.usedSeats}/${seatStatus.totalSeats}). Upgrade plan to generate ID.`
              : ""
          }
          arrow
          placement="left"
        >
          <span>
            <MenuItem 
              onClick={() => handleGenerateID(selectedMenuCandidate)}
              disabled={
                selectedMenuCandidate?.offerStatus?.toLowerCase() !== "accepted" || 
                selectedMenuCandidate?.employeeidgenerated ||
                Boolean(seatStatus?.isLimitReached) ||
                Boolean(seatStatus?.isExpired)
              }
            >
              <ListItemIcon>
                <Fingerprint fontSize="small" />
              </ListItemIcon>
              <ListItemText>Generate Employee ID</ListItemText>
            </MenuItem>
          </span>
        </Tooltip>
      </Menu>

      {/* Background Verification Dialog */}
      <Dialog 
        open={verificationDialogOpen} 
        onClose={handleCloseVerificationDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, backgroundColor: '#f5f5f5' }}>
          <VerifiedUser color="primary" />
          Background Verification Request
        </DialogTitle>
        
        <DialogContent>
          <Box sx={{ pt: 2 }}>
            <Alert severity="info" sx={{ mb: 3 }}>
              Send background verification request to the candidate's previous company HR
            </Alert>

          

            {/* Candidate Details Section */}
            <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
              <Person color="primary" />
              Candidate Details
            </Typography>
            
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Full Name"
                  value={dialogCandidate?.name || ''}
                  margin="normal"
                  disabled
                  InputProps={{
                    startAdornment: <Person color="action" sx={{ mr: 1 }} />
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Email"
                  value={dialogCandidate?.candidateEmail || ''}
                  margin="normal"
                  disabled
                  InputProps={{
                    startAdornment: <Email color="action" sx={{ mr: 1 }} />
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Position Applied"
                  value={dialogCandidate?.positionApplied || ''}
                  margin="normal"
                  disabled
                  InputProps={{
                    startAdornment: <Work color="action" sx={{ mr: 1 }} />
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Hiring Manager"
                  value={dialogCandidate?.hiringManagerEmail || ''}
                  margin="normal"
                  disabled
                  InputProps={{
                    startAdornment: <Business color="action" sx={{ mr: 1 }} />
                  }}
                />
              </Grid>
            </Grid>

            <Divider sx={{ my: 2 }} />

            {/* Previous Company Email Section */}
            <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
              <Business color="primary" />
              Previous Company Details
            </Typography>

            <TextField
              fullWidth
              label="Previous Company HR Email"
              value={previousCompanyEmail}
              onChange={(e) => setPreviousCompanyEmail(e.target.value)}
              margin="normal"
              required
              placeholder="hr@previouscompany.com"
              helperText="Enter the email address of the HR department from candidate's previous company"
              InputProps={{
                startAdornment: <Email color="action" sx={{ mr: 1 }} />
              }}
            />

            <Alert severity="warning" sx={{ mt: 2 }}>
              <Typography variant="body2">
                A background verification email will be sent to the specified HR email address. 
                Please ensure you have the candidate's consent before proceeding.
              </Typography>
            </Alert>
          </Box>
        </DialogContent>
        
        <DialogActions sx={{ p: 3 }}>
          <Button 
            onClick={handleCloseVerificationDialog} 
            disabled={sendingVerification}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button 
            onClick={handleSendVerification}
            variant="contained"
            disabled={sendingVerification || !previousCompanyEmail}
            startIcon={sendingVerification ? <CircularProgress size={16} /> : <VerifiedUser />}
            sx={{ minWidth: 140 }}
          >
            {sendingVerification ? 'Sending...' : 'Send Request'}
          </Button>
        </DialogActions>
      </Dialog>

      <EmployeeIDForm 
        open={employeeFormOpen}
        onClose={handleCloseEmployeeForm}
        candidateData={selectedCandidate}
      />
    </Box>
  );
};

export default OfferManagementCandidate;   